import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { getApps, getApp } from "firebase/app"; // ✅ CORRECTION: Utiliser l'app existante
import { getMessaging, getToken } from "firebase/messaging"; // ✅ CORRECTION: Import getToken

// ✅ CORRECTION: Utiliser l'app Firebase existante (pas de réinitialisation)
const app = getApps().length > 0 ? getApp() : null;

// Configuration des notifications push
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js') // ✅ CORRECTION: Bon nom de fichier
    .then((registration) => {
      console.log('✅ Service Worker enregistré:', registration.scope);
      
      // ✅ CORRECTION: Vérifier que Firebase est initialisé
      if (app) {
        const messaging = getMessaging(app); // ✅ CORRECTION: Utiliser l'app existante
        return getToken(messaging, { // ✅ CORRECTION: Syntaxe correcte v9
          vapidKey: process.env.REACT_APP_FIREBASE_MESSAGING_PUBLIC_KEY,
        });
      } else {
        throw new Error('Firebase app non initialisée');
      }
    })
    .then((token) => {
      if (token) {
        console.log('✅ FCM Token obtenu:', token.slice(0, 20) + '...');
        // Optionnel: Sauvegarder le token si nécessaire
        // localStorage.setItem('fcm_token', token);
      } else {
        console.log('❌ Aucun token FCM disponible');
      }
    })
    .catch((err) => {
      console.log('❌ Erreur lors de l\'enregistrement du service worker:', err);
      
      // Diagnostic détaillé des erreurs
      if (err.name === 'NotSupportedError') {
        console.log('🚫 Service Workers non supportés dans ce navigateur');
      } else if (err.name === 'SecurityError') {
        console.log('🔒 Erreur de sécurité - HTTPS requis ou domaine non autorisé');
      } else if (err.message.includes('firebase-messaging-sw.js')) {
        console.log('📁 Fichier firebase-messaging-sw.js non trouvé dans /public');
      } else {
        console.log('❓ Erreur inconnue:', err.message);
      }
    });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);